import MainFooter from "./mainFooter";
import './footer.css'	


export default function Footer() {
	return (
		<footer id="footer">
			<MainFooter />
		</footer>
	)
}